import React from 'react';
import Layout from '../components/layout';
import SEO from '../components/seo';
import Head from '../components/globals/Head';
import '../components/ImagesPageComponents/Images.css';
import { graphql } from 'gatsby';
import Img from 'gatsby-image';

const ImageVitrayDC = (props) => (
	<Layout>
		<SEO title="Image-VitrayD" keywords={[ `masu`, `design`, `front-end web developing` ]} />
		<Head />
		<section className="container-image">
			<div class="images-wrap-vitraj">
				<Img alt="stylized sea with ships" fluid={props.data.imageVitrajDC.childImageSharp.fluid} />
				<div class="text-vitraj">
					<p>The legends pub, 2008</p>
					<p className={'text1-vitraj'}>stained glass draft</p>
				</div>
			</div>
		</section>
	</Layout>
);
export default ImageVitrayDC;
export const pageQuery = graphql`
	query {
		imageVitrajDC: file(relativePath: { eq: "Vitraj-D-C-opt.png" }) {
			childImageSharp {
				fluid(maxWidth: 1000) {
					...GatsbyImageSharpFluid_withWebp
				}
			}
		}
	}
`;
